import type { SelectAsyncCreatableProps, SelectProps } from './index'
import { mergeStyle } from './index'
import type { MenuPlacement } from 'react-select'
import { getWindow } from '@ztechapps/common.utils'
import type { FieldEditorInjectedProps } from '../FieldEditorInjectedProps'

export const useReactSelect = ({
  submitting,
  disabled,
  isMaxWidth = true,
  styles,
  theme: _theme, // Rename to indicate intentionally unused
  isDisabled,
  formatCreateLabel,
  isMulti,
  menuPortalTarget,
  menuPlacement,
  form: _form,
  meta: _meta,
  ...rest
}: SelectProps & SelectAsyncCreatableProps & Pick<FieldEditorInjectedProps, 'form' | 'meta'>) => {
  return {
    formatCreateLabel:
      formatCreateLabel ??
      ((inputValue: string) => {
        return `Press TAB to create "${inputValue}"`
      }),
    isDisabled: submitting || disabled || isDisabled,
    styles: mergeStyle(styles, isMaxWidth),
    isClearable: true,
    autoFocus: true,
    isMulti,
    closeMenuOnSelect: !isMulti,
    ...rest,
    escapeClearsValue: true,
    className: 'react-select-container',
    classNamePrefix: 'react-select',
    // Treat `menuPlacement` as a default — `??` so a consumer's explicit value wins. Previously
    // this was a hardcoded override AFTER `...rest`, which silently dropped any `menuPlacement`
    // a caller passed. Affected the spreadsheet cell's attempt to use `'top'` for the trailing
    // row near the bottom of the modal.
    menuPlacement: (menuPlacement ?? 'auto') as MenuPlacement,
    // Default to `document.body` ONLY when the caller did not pass `menuPortalTarget` at all.
    // Use `undefined` check (NOT `??`) so an explicit `null` from the caller — meaning "render
    // the menu inline, do NOT portal" — survives. Spreadsheet cells use `null` to render the
    // menu inside the parent modal's scrollable body so react-select's auto-flip can detect
    // the modal's bounds instead of the (much taller) document.
    menuPortalTarget: menuPortalTarget === undefined ? getWindow()?.document?.body : menuPortalTarget,
  }
}
